module.exports = __webpack_public_path__ + "img/guide1-9.fb60dca3.png";